module.exports = __webpack_public_path__ + "static/media/web.0ca4bf5c.jpg";